export const breakpoints = [
  '30em', //  xs  480px
  '36em', //  sm  576px
  '48em', //  md  768px
  '62em', //  lg  992px
  '75em', //  xl  1200px
  '90em', // xxl  1440px
];
